__turbopack_context__.v({
  "add": "TeamAddCard-module-scss-module__cBMilG__add",
  "card": "TeamAddCard-module-scss-module__cBMilG__card",
  "cardList": "TeamAddCard-module-scss-module__cBMilG__cardList",
  "div": "TeamAddCard-module-scss-module__cBMilG__div",
  "text": "TeamAddCard-module-scss-module__cBMilG__text",
});
